import GameContainer from "./GameContainer/GameContainer";
import {WebsiteHeader} from "./WebsiteHeader";

function App() {
  return (<>
    <WebsiteHeader/>
    <GameContainer/>
    </>
  );
}


export default App;
